'use client';

import { useState, useEffect } from 'react';

/** True quando o app está rodando como PWA instalado (standalone). */
export function useIsPwaStandalone(): boolean {
  const [standalone, setStandalone] = useState(false);

  useEffect(() => {
    setStandalone(
      window.matchMedia('(display-mode: standalone)').matches ||
        (navigator as { standalone?: boolean }).standalone === true
    );
  }, []);

  return standalone;
}
